<template>
  <div class="enterprise-page">
    <div class="video">
      <NuxtImg
        :src="`${cdnUrl}/static/images/particles.png`"
        alt="AI-powered 360 photo and panorama created from smartphone using Travvir"
        :preload="true"
        fetch-priority="high"
      />
    </div>
    <div class="hero-section" :class="{ isAndroid: !$isIPhone }">
      <div class="des1">
        <NuxtImg
          class="first-des"
          :src="`${cdnUrl}/static/images/introducing-agustus-ai.svg`"
          alt="AI powered spatial image for 360 virtual tour"
          preload
          fetch-priority="high"
        />
      </div>
      <div class="title">
        <div class="parent-img">
          <UsageChip />
          <h1>Create Digital Twins from your phone</h1>
          <NuxtImg
            class="mark"
            alt="AI powered spatial image for 360 virtual tour"
            :src="`${cdnUrl}/static/images/mark.svg`"
            preload
            fetch-priority="high"
            width="100%"
            height="auto"
          />
        </div>

        <div class="des">
          <CtaDownloads msg="Sales Inquiry from landing page" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { usePropertyStore } from "~/store/property";

const propertyStore = usePropertyStore();
let propertyId = "W4KyJj";
await propertyStore.getProperty(propertyId);
const config = useRuntimeConfig();
const { $isIPhone } = useNuxtApp();
const cdnUrl = config.public.NUXT_CDN_URL;
</script>

<style lang="scss" scoped>
.enterprise-page {
  color: white;
  position: relative;
  height: 100dvh;
  overflow: hidden;
  .video {
    position: absolute;
    top: 0%;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    height: 200dvh;
    object-fit: cover;
    filter: blur(1.5rem) contrast(1.2) brightness(0.85);
    @include respond-below(sm) {
      min-height: calc(var(--vh, 1vh) * 200);
      height: 200dvh;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .hero-section {
    padding: 4rem 0;
    position: relative;
    min-height: calc(var(--vh, 1vh) * 100);
    display: flex;
    padding: 6rem 0;
    background: transparent;
    text-align: center;
    justify-content: center;
    &.isAndroid {
      @include respond-below(sm) {
        min-height: 100dvh;
      }
    }
    @include respond-below(sm) {
      padding: 4rem 0;
      min-height: calc(var(--vh, 1vh) * 100);
    }
    .des1 {
      width: 100%;
      position: absolute;
      bottom: 3.2rem;
      .first-des {
        padding: 1.3rem 1rem;
        height: unset !important;
        width: 38%;
        margin-inline: auto;
        @include respond-below(sm) {
          width: 90%;
        }
      }
      @include respond-below(sm) {
        bottom: 1rem;
      }
    }
    .title {
      position: absolute;
      z-index: 3;
      top: 42%;
      transform: translateY(-41%);
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      // letter-spacing: -8.68px;
      line-height: 142.6px;
      .parent-img {
        width: 100%;
        max-width: 660px;
        position: relative;
        h1 {
          // width: 60%;
          font-weight: 800;
          text-wrap: balance;
          font-family: "Plus Jakarta Sans", sans-serif;
          font-size: 70px;
          line-height: 77px;
          letter-spacing: -0.02em;
          @include respond-below(sm) {
            font-size: 10vw;
            line-height: 10vw;
          }
        }
        .mark {
          object-fit: contain;
          position: absolute;
          bottom: -1.3rem;
          width: 200px;
          right: 0rem;
          @include respond-below(sm) {
            width: 20vw;
            right: 14vw;
            bottom: -3rem;
          }
        }
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        &__top {
          // margin-top: 3rem;
          width: 52%;
          object-fit: contain;
          @include respond-below(sm) {
            width: 90%;
            height: unset !important;
          }
        }
      }
      .des {
        margin-top: 1.5rem;
        display: flex;
        gap: 0rem;
        flex-direction: column-reverse;
        width: 100%;
        .cta-btn {
          margin-top: 1.2rem;
          display: flex;
          gap: 0.5rem;
          justify-content: center;
          align-items: center;
          $cta-height: 2.75rem;
          .try-now-btn,
          .contact-sales {
            min-height: $cta-height;
            box-sizing: border-box;
            border-radius: 50px;
            font-family: "Sharp Grotesk";
            // font-family:;
            // font-family: "Plus Jakarta Sans", sans-serif;
            @include respond-below(sm) {
              min-height: 2.375rem;
            }
          }
          .try-now-btn {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 0.625rem;
            padding: 12px 20px;
            // background: rgba(255, 255, 255, 1);
            background: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.1);
            // border: 1px solid rgba(255, 255, 255, 0.2);
            pointer-events: auto;
            &:hover {
              background: rgba(255, 255, 255, 0.2);
              border: 1px solid rgba(255, 255, 255, 0.2);
            }
            @include respond-below(sm) {
              padding: 0.3rem 0.6rem 0.3rem 0.85rem;
              gap: 0.5rem;
            }
            &__label {
              flex-shrink: 0;
              font-size: 1rem;
              font-weight: 600;
              line-height: 1;
              letter-spacing: 0.02em;
              color: rgba(255, 255, 255, 1);
              white-space: nowrap;
              @include respond-below(sm) {
                font-size: 0.7rem;
              }
            }
            &__chips {
              display: flex;
              align-items: center;
              gap: 0.35rem;
            }
            &__chip {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              gap: 0.25rem;
              padding: 0.25rem 0.65rem;
              // background: rgba(0, 0, 0, 0.05);
              background: rgba(255, 255, 255, 1);

              border: 1px solid rgba(0, 0, 0, 0.08);
              border-radius: 999px;
              box-shadow:
                0 1px 2px rgba(0, 0, 0, 0.06),
                0 1px 3px rgba(0, 0, 0, 0.1);
              text-decoration: none;
              color: rgba(14, 14, 14, 0.9);
              font-size: 0.8125rem;
              font-weight: 500;
              line-height: 1;
              transition: all 0.2s ease;
              img {
                width: 14px;
                height: 14px;
                object-fit: contain;
                flex-shrink: 0;
              }
              &:hover {
                // background: rgba(0, 0, 0, 0.09);
                // background: rgba(255, 255, 255, 0.2);
                // border-color: rgba(255, 255, 255, 0.2);
                // box-shadow:
                //   0 2px 4px rgba(0, 0, 0, 0.08),
                //   0 2px 6px rgba(0, 0, 0, 0.12);
                transform: translateY(-1px);
              }
              @include respond-below(sm) {
                padding: 0.2rem 0.55rem;
                font-size: 0.75rem;
                img {
                  width: 13px;
                  height: 13px;
                }
              }
            }
          }
          button {
            pointer-events: auto;
            cursor: pointer;
            // font-family: "Plus Jakarta Sans", sans-serif;
            display: flex;
            align-items: center;
            justify-content: center;
            width: fit-content;
            padding: 12px 20px;
            font-weight: 500;
            font-size: 1rem;
            border-radius: 50px;
            transition: all 0.3s ease;
            &:hover {
              opacity: 1;
            }
            @include respond-below(sm) {
              font-size: 0.9rem;
              justify-content: center;
              padding: 8px 12px;
            }
          }
          .contact-sales {
            background: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.1);
            color: white;
            a {
              color: inherit;
              text-decoration: none;
            }
            &:hover {
              background: rgba(255, 255, 255, 0.2);
              border: 1px solid rgba(255, 255, 255, 0.2);
            }
          }
        }
      }
      @include respond-below(sm) {
        top: 0px;
        transform: translateY(0px);
        width: 100%;
        height: calc(var(--vh, 1vh) * 80);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        img {
          height: 70px;
          width: 80%;
          padding: 0%;
        }
      }
    }
  }
}

@keyframes usage-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.65;
    transform: scale(0.88);
  }
}
</style>
